export const balanceStateName = 'balance';

export const balanceInitialState = {
    balance: {rubles: null, bonuses: null, loading: false},
};
